import { useState, useEffect } from "react";
import { DrawerComponent, DrawerPercentageType, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { addItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import moment from "moment";
import { fieldsInAddAction } from "../constants";
import Form from "src/components/Form";
import { selectAddStatus, selectItems, selectJustAddedItem } from "src/modules/spItems/selectors";
import { myTaskMeetingsListName } from "src/api/config/meetings.config";
import { addUsers } from "src/modules/users/actions";
import { addItem } from "src/modules/spItems/actions";
import {
  myTaskActionsHistoryListName,
  myTaskActionsListName,
  myTasksTagsListName,
} from "src/api/config/myTasksActions.config";
import Loading from "src/components/Loading";
import { RootState } from "src/store/rootReducer";
import { emailsSender, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ClosePanelBtnMobile } from "src/components/DialogComponent";
import { myTasksDepartmentsListName, myTasksLocationsListName, myTasksRegionsListName } from "src/api/config/myTasksLists.config";
import { actionsStatus } from "src/api/config/systemSwitch";
import { autoCloseModal } from "src/constants";
const { sendEmail } = emailAPI();

const AddActionInModal = ({
  zIndex,
  meetingID,
  percentage,
}: {
  zIndex: number;
  meetingID: number;
  percentage?: DrawerPercentageType;
}) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const [open, setOpen] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [closeAllModals, setCloseAllModals] = useState(false);
  const [fields, setFields] = useState<any>(fieldsInAddAction); // Оставляем манёвр для динамического добавления полей, в зависимости от настроек совещания
  const [formData, setFormData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({
    Status: actionsStatus.notStart
  });
  const [meetings, setMeetings] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const statusAddAction = useAppSelector((state) => selectAddStatus(state, myTaskActionsListName));
  const idAddActionCard = useAppSelector((state) => selectJustAddedItem(state, myTaskActionsListName));
  const [isSelectMeetings, setIsSelectMitings] = useState<any>(false);
  const [isSelectResponsible, setIsSelectResponsible] = useState<any>(false);
  const [customLoading, setCustomLoading] = useState(false);
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const [addAction, setAddAction] = useState(false);
  const [query, setQuery] = useSearchParams();
  const navigate = useNavigate();
  const locations: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
  const departments: any = useAppSelector((state) => selectItems(state, myTasksDepartmentsListName));
  const regions: any = useAppSelector((state) => selectItems(state, myTasksRegionsListName));

  function getResponsibleOptions(meeting: any) {
    const owners = meeting.owners.split(",").map((owner: string) => {
      owner = owner.trim();
      return {
        value: (users[owner] && users[owner].email) || owner,
        label: (users[owner] && users[owner].displayName) || owner,
        avatar: (users[owner] && users[owner].avatar) || null,
      };
    });

    const participants =
      (meeting.participants &&
        meeting.participants.split(",").map((participant: string) => {
          participant = participant.trim();
          return {
            value: (users[participant] && users[participant].email) || participant,
            label: (users[participant] && users[participant].displayName) || participant,
            avatar: (users[participant] && users[participant].avatar) || null,
          };
        })) ||
      [];

    return _.uniqBy([...owners, ...participants], "value");
  }

  useEffect(() => {
    setOpen(false);
    setCancel(false);
  }, [closeAllModals]);

  useEffect(() => {
    if (statusAddAction === "SUCCESS") {
      setAddAction(true);
    }
  }, [statusAddAction]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      //* Проверка на пустую строку у поля Description
      if (!formData.Description.trim()) return;
      const sendData = {
        Title: `Action #${Math.floor(Math.random() * 1000)}`,
        Responsible: formData.Responsible[0]["value"],
        Meeting: formData.Meeting.id,
        Description: formData.Description.trim() + " ",
        Status: formData.Status,
        AuthorEmail: currentUser.email.toLowerCase().trim(),
        ResponsibleEmail: formData.Responsible[0]["value"].toLowerCase().trim(),
        DateForDone:
          (typeof formData.DateForDone.startDate === "string" && new Date(formData.DateForDone.startDate)) ||
          formData.DateForDone.startDate,
        OtherFieldsValues: JSON.stringify(fields.filter((field: any) => field.key.indexOf('_custom_') !== -1).map((field: any) => {
          return { [field.key]: formData[field.key] }
        }))
      };
      if (
        moment(sendData.DateForDone).clone().add(1, "days").startOf("day").unix() <
        moment(new Date()).clone().startOf("day").unix()
      ) {
        sendData["Status"] = actionsStatus.old;
      }
      const hashTags = sendData.Description.match(/(^|\W)(#[а-я\w][а-я\w-]*)/gi) || [];
      setCustomLoading(true);
      if (hashTags.length > 0) {
        getItemsRequest({ listName: myTasksTagsListName, filters: { Title: hashTags } }).then((results: any) => {
          const hashTagsInSP = [...results.items];
          let addHashTags: any = [];
          hashTags.forEach((tag: string) => {
            if (hashTagsInSP.filter((tagInSP: any) => tagInSP.Title === tag).length === 0) {
              addHashTags = [
                ...addHashTags,
                {
                  Title: tag,
                },
              ];
            }
          });
          if (addHashTags.length > 0) {
            addItemRequest({ listName: myTasksTagsListName, bodyArr: addHashTags, body: addHashTags[0] }).then(() => {
              setCustomLoading(false);
              dispatch(addItem({ listName: myTaskActionsListName, body: sendData, updateReducer: true }));
            });
          } else {
            setCustomLoading(false);
            dispatch(addItem({ listName: myTaskActionsListName, body: sendData, updateReducer: true }));
          }
        });
      } else {
        setCustomLoading(false);
        dispatch(addItem({ listName: myTaskActionsListName, body: sendData, updateReducer: true }));
      }
    }
  }, [formData]);

  //Добавление истории
  useEffect(() => {
    if (idAddActionCard) {
      if (emailsSender) {
        const timestamp = moment().unix();
        const sendData: any = {};
        sendData["DateForDone"] =
          (typeof formData.DateForDone.startDate === "string" && new Date(formData.DateForDone.startDate)) ||
          formData.DateForDone.startDate;
        const emailBody = {
          Body: `Здравствуйте ${formData.Responsible[0]["label"]},<br/><br/>Сотрудник ${
            currentUser.displayName
          } создал новое действие и назначил Вас ответственным за него:<br/><br/><ul><li>Совещание: <a href="${siteUrl}/App/default.aspx/dashboard/3/meetings?meetingCardMobile=${
            formData.Meeting.id
          }">${
            formData.Meeting.name
          }</a></li><li>Описание действия: <a href="${siteUrl}/App/default.aspx/dashboard/3?actionCardMobile=${idAddActionCard}">${formData.Description.trim()}</a></li><li>Срок: ${moment(
            sendData.DateForDone
          )
            .clone()
            .format("DD.MM.YYYY")}</li></ul>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Создание нового действия",
          Subject: "Мои Задачи | Создание нового действия",
          Recepients: formData.Responsible[0]["value"],
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setFormData(null);
        });
      }
      const historyData = {
        Title: `History action card #${idAddActionCard}`,
        Action: idAddActionCard,
        Status: actionsStatus.created //Действие создано
      };
      addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData });
    }
  }, [idAddActionCard]);

  useEffect(() => {
    if (meetings.length === 0) {
      getItemsRequest({
        listName: myTaskMeetingsListName,
        viewFields: ["ID", "Title", "Owners", "Participants", "Status", "AdditionalFields"],
      }).then((result: any) => {
        const tempSelectMeetings = result.items.map((item: any) => {
          return {
            id: item.ID,
            name: item.Title,
            owners: item.Owners,
            participants: item.Participants,
            status: item.Status,
            fields: item.AdditionalFields
          };
        });
        if (tempSelectMeetings.length > 0) {
          setMeetings([...tempSelectMeetings]);
        }
      });
    }
  }, [meetings]);

  useEffect(() => {
    if (meetings.length > 0) {
      const meeting = meetings.filter((meeting: any) => meeting.id === Number(meetingID))[0];
      if (meeting) {
        let usersEmail: any = [];
        usersEmail = (meeting.owners && [
          ...usersEmail,
          ...meeting.owners.split(",").map((owner: string) => owner.trim()),
        ]) || [...usersEmail];
        usersEmail = (meeting.participants && [
          ...usersEmail,
          ...meeting.participants.split(",").map((participant: string) => participant.trim()),
        ]) || [...usersEmail];
        usersEmail = _.uniqWith(usersEmail, _.isEqual);
        if (usersEmail.length > 0) {
          dispatch(addUsers(usersEmail));
        }
      }
      setDefaultValues((prevState: any) => {
        return {
          ...prevState,
          ...{ Meeting: meeting },
        };
      });
    }
  }, [meetingID, meetings]);

  useEffect(() => {
    if (meetingID && meetings.some((meeting: any) => meeting.id === meetingID)) {
      const meeting = meetings.filter((meeting: any) => meeting.id === meetingID)[0];
      const tempFieldsForm: any = [...fieldsInAddAction];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Meeting") {
          tempFieldsForm[i]["disabled"] = true;
        }
        if (tempFieldsForm[i]["key"] === "Responsible") {
          tempFieldsForm[i]["options"] = getResponsibleOptions(meeting);
        }
      }

      if (meeting.fields && JSON.parse(meeting.fields).length > 0) {
        setFields([...fieldsInAddAction]);
        const meetingFields = JSON.parse(meeting.fields);
        let tempFields: any = [];
        meetingFields.forEach((field: any, idx: number) => {
          if (field.type === 'location') {
            tempFields = [...tempFields, {
              type: 'select',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full',
              options: locations.map((location: any) => {
                return {
                  id: location.ID,
                  name: location.Title,
                  available: true
                };
              })
            }]
          }
          if (field.type === 'department') {
            tempFields = [...tempFields, {
              type: 'select',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full',
              options: departments.map((department: any) => {
                return {
                  id: department.ID,
                  name: department.Title,
                  available: true
                };
              })
            }]
          }
          if (field.type === 'sector') {
            tempFields = [...tempFields, {
              type: 'select',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full',
              options: regions.map((region: any) => {
                return {
                  id: region.ID,
                  name: region.Title,
                  available: true
                };
              })
            }]
          }
          if (field.type === 'date') {
            tempFields = [...tempFields, {
              type: 'date',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full'
            }]
          }
          if (field.type === 'employee') {
            tempFields = [...tempFields, {
              type: 'peoplePicker',
              require: false,
              single: true,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              current: false,
              placeholder: field.value.name,
              width: 'w-full'
            }]
          }
          if (field.type === 'single') {
            tempFields = [...tempFields, {
              type: 'select',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full',
              options: field.options.map((option: any) => {
                return {
                  id: option.id,
                  name: option.name,
                  available: true
                };
              })
            }]
          }
          if (field.type === 'free') {
            tempFields = [...tempFields, {
              type: 'textArea',
              key: `${field.type}_custom_${idx}`,
              require: false,
              title: field.name,
              placeholder: field.value.name,
              width: 'w-full'
            }]
          }
          if (field.type === 'many') {
            tempFields = [...tempFields, {
              type: 'checkbox',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              width: "w-full",
                optionsInputs: (field.options && field.options.map((option: any) => option.name.trim())) || []
            }]
          }
          if (field.type === 'grade') {
            tempFields = [...tempFields, {
              type: 'grade',
              require: false,
              key: `${field.type}_custom_${idx}`,
              title: field.name,
              width: "w-full"
            }]
          }
        });
        setFields([...tempFieldsForm, ...tempFields]);
      } else {
        setFields([...tempFieldsForm]);
      }
    } else if ((meetingID === 0 || !meetingID) && meetings.length > 0) {
      const tempFieldsForm: any = [...fieldsInAddAction];
      const meeting = meetings.filter((meeting: any) => isSelectMeetings && meeting.id === isSelectMeetings.id)[0] || null;
      if (isSelectMeetings && !isSelectResponsible && meeting) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Responsible") {
            tempFieldsForm[i]["options"] = getResponsibleOptions(meeting);
          }
        }
      }
      if (!isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants && meeting.participants.indexOf(isSelectResponsible.value) !== -1)
              )
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFieldsForm[i]["options"].length === 0) {
              tempFieldsForm[i]["options"] = [
                {
                  id: 0,
                  name: "Совещания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }
        }
      }
      if (!isSelectMeetings && !isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Responsible") {
            tempFieldsForm[i]["options"] = [];
          }
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                };
              });
          }
        }
      }
      if (isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants && meeting.participants.indexOf(isSelectResponsible.value) !== -1)
              )
              .filter((meeting: any) => meeting.id !== isSelectMeetings.id && meeting.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFieldsForm[i]["options"].length === 0) {
              tempFieldsForm[i]["options"] = [
                {
                  id: 0,
                  name: "Совещания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }
          if (tempFieldsForm[i]["key"] === "Responsible" && meeting) {
            tempFieldsForm[i]["options"] = getResponsibleOptions(meeting);
          }
        }
      }
      setFields([...tempFieldsForm]);

    }
  }, [isSelectMeetings, isSelectResponsible, meetingID, meetings, users]);

  const openNewActionHandle = () => {
    setOpen(false);
    setCancel(false);
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("actionCardMobile", idAddActionCard.toString());
    setQuery(newSearchParams);
    navigate(0);
  };

  return (
    <>
      <Button
        open={open}
        setOpen={setOpen}
        typeIcon="add"
        classBg="btn-white w-full justify-center"
        shadow
        text="Добавить действие"
        icon={true}
      />

      <DrawerComponent
        zIndex={zIndex}
        open={open}
        setOpenCustomModal={setCancel}
        toggleDrawer={setOpen}
        percentage={percentage}
      >
        <div className="flex flex-col shrink">
          <div className="flex justify-between items-center p-6 border-b">
            <h1 className="text-base font-medium text-black">Добавить действие</h1>
            <ClosePanelBtnMobile toggleDrawer={setOpen} hideXMarkIcon={false} />
          </div>
          {((statusAddAction === "LOADING" || customLoading) && (
            <div className="flex items-center justify-center w-full mt-5 mb-5">
              <Loading />
            </div>
          )) || (
            <div className="px-6 pt-6 mobile-form">
              <Form
                type="add_action_in_modal"
                setFormData={setFormData}
                fieldsForm={fields}
                setOpenCancelAddCard={setCancel}
                openCancelAddCard={cancel}
                defaultValues={defaultValues}
                textButtonSubmit="Создать действие"
                setIsSelectMitings={setIsSelectMitings}
                setIsSelectResponsible={setIsSelectResponsible}
              />
            </div>
          )}
        </div>
      </DrawerComponent>

      <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={cancel} toggleDialog={setCancel}>
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          <p>
            Вы уверены, что хотите закрыть окно?
            <br />
            Вся введенная вами информация будет сброшена.
            <br />
            Заполните все обязательные поля, чтобы сохранить действие.
          </p>
        </div>

        <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={() => setCloseAllModals(!closeAllModals)}>
            Закрыть без сохранения
          </TGButton>
          <TGButton color="bluedark" onClick={() => setCancel(false)}>
            Вернуться к действию
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={addAction}
        toggleDialog={setAddAction}
        autoClose={autoCloseModal}
        onAutoClose={() => {
          openNewActionHandle();
        }}
      >
        <header className="px-10 pb-4">
          <h2>Вы успешно сохранили действие</h2>
        </header>

        <div className="px-10 py-5">
          <p>Действие сохранено со всеми изменениями</p>
        </div>

        <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="bluedark" onClick={() => openNewActionHandle()}>
            Закрыть
          </TGButton>
        </footer>
      </Modal>
    </>
  );
};

export default AddActionInModal;
